import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Footer from '../components/Footer';
import { useSafeBack } from '../hooks/useSafeBack';

const About = () => {
  const navigate = useNavigate();
  const { goBack } = useSafeBack('/');

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-8">
          {/* Back Button + Home */}
          <div className="flex items-center gap-2 mb-6">
            <Button
              variant="ghost"
              onClick={goBack}
              className="h-10 px-0 text-sm font-medium text-zinc-500 hover:text-zinc-900 hover:bg-transparent"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/dashboard')}
              className="h-8 w-8"
              data-testid="nav-home-btn"
              aria-label="Home"
            >
              <Home className="w-4 h-4 text-zinc-400" />
            </Button>
          </div>

          {/* Header */}
          <h1 className="text-3xl font-bold text-zinc-900 mb-8">About Open Runs</h1>

          {/* Content */}
          <div className="prose prose-zinc max-w-none space-y-6">
            <p className="text-zinc-700 text-lg leading-relaxed">
              Open Runs USA helps basketball players easily find and organize pickup games.
            </p>
            <p className="text-zinc-700 text-lg leading-relaxed">
              Players can create runs, join games nearby, and build a reliable community of hoopers.
            </p>
            <p className="text-zinc-700 text-lg leading-relaxed">
              The goal is simple: make it easier to find quality runs and eliminate the frustration of showing up to empty courts.
            </p>
            <p className="text-zinc-700 text-lg leading-relaxed font-medium">
              Open Runs focuses on reliability, community, and great basketball.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
